import { useMemo } from 'react'

import { useIsEInvoicingOnly } from '@features/bills/hooks/useIsEInvoicingOnly'

import { Scope } from '../../../../../enums/scope'
import { useOrganizationSource } from '../../../../../hooks'
import { isAuthorized } from '../../../../../utils/isAuthorized'

export const useShouldDisplayInvoicingSettingsTab = () => {
  const { isSourceBilly } = useOrganizationSource()
  const isEInvoicingOnly = useIsEInvoicingOnly()

  const shouldDisplayInvoicingSettingsTab = useMemo(() => {
    if (isSourceBilly) {
      return isAuthorized(Scope.InvoiceWrite)
    } else {
      return !isEInvoicingOnly
    }
  }, [isSourceBilly, isEInvoicingOnly])

  return { shouldDisplayInvoicingSettingsTab }
}
